import React, { useState, useEffect } from "react";
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL_PROD // https://demenagementsamyyhaul.ca/api
    : process.env.REACT_APP_API_URL_DEV; // http://158.69.205.231:3000


const CollaborationForm = () => {
  const [formData, setFormData] = useState({
    nom: "",
    telephone: "",
    email: "",
    service: "",
    typeCollaboration: "",
    description: "",
  });

  const [services, setServices] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
useEffect(() => {
  fetch(`${API_BASE_URL}/services`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Erreur HTTP ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      if (data.statusCode === 200 && data.data?.services) {
        setServices(data.data.services);
      }
    })
    .catch((err) => {
      console.error("Erreur API services :", err);
    });
}, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setSubmitMessage("");

  try {
    console.log("🚀 [Collaboration] Début de soumission...");

    // 🔹 Récupération des infos utilisateur si connecté
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const email = currentUser.email || formData.email;
    const guestToken = localStorage.getItem("guestToken") || null;

    console.log("📩 Données à envoyer :", {
      ...formData,
      email,
      guestToken,
      statut: "En cours",
    });

   const response = await fetch(`${API_BASE_URL}/Collaboration`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    ...formData,
    email,
    guestToken,
    statut: "En cours",
  }),
});

    console.log("📡 Réponse brute :", response);

    if (!response.ok) {
      console.error("❌ Erreur API :", response.status, response.statusText);
      throw new Error("Erreur lors de l'envoi");
    }

    const data = await response.json();
    console.log("✅ Collaboration créée :", data);

    setSubmitMessage(`✅ Demande envoyée avec succès ! Statut: ${data.statut}`);

    // Réinitialisation
    setFormData({
      nom: "",
      telephone: "",
      email: "",
      service: "",
      typeCollaboration: "",
      description: "",
    });
  } catch (error) {
    console.error("🔥 Erreur handleSubmit :", error);
    setSubmitMessage("❌ Une erreur est survenue. Veuillez réessayer.");
  } finally {
    setIsSubmitting(false);
    console.log("🏁 [Collaboration] Soumission terminée");
  }
};



  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <br /> <br /> <br />
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Demande de Collaboration Entreprise
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Vous êtes une entreprise et souhaitez établir un partenariat avec
            nous ? Remplissez ce formulaire et nous vous contacterons
            rapidement.
          </p>
        </div>
        {/* Formulaire */}
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-2xl rounded-2xl overflow-hidden"
        >
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 px-8 py-6">
            <h2 className="text-2xl font-bold text-white flex items-center">
              <svg
                className="w-8 h-8 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              Informations de votre entreprise
            </h2>
          </div>

          <div className="p-8 space-y-8">
            {/* Informations de base */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Nom de l'entreprise *
                </label>
                <input
                  type="text"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors"
                  placeholder="Ex: Entreprise ABC Inc."
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Téléphone *
                </label>
                <input
                  type="tel"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors"
                  placeholder="Ex: +216 99 999 999"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors"
                  placeholder="Ex: contact@entreprise.com"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Service concerné *
                </label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors"
                >
                  <option value="">Sélectionnez un service</option>
                  {services.map((service) => (
                    <option key={service.id} value={service.name}>
                      {service.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Type de collaboration */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Type de collaboration *
              </label>
              <select
                name="typeCollaboration"
                value={formData.typeCollaboration}
                onChange={handleInputChange}
                required
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors"
              >
                <option value="">Sélectionnez un type</option>
                <option value="Partenariat">Partenariat</option>
                <option value="Fourniture de services">
                  Fourniture de services
                </option>
                <option value="Projet commun">Projet commun</option>
                <option value="Autre">Autre</option>
              </select>
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Description / Détails supplémentaires
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows="4"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors"
                placeholder="Décrivez votre projet ou collaboration..."
              ></textarea>
            </div>

            {/* Bouton de soumission */}
            <div className="text-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full md:w-auto px-6 py-3 rounded-lg text-white font-semibold transition-colors ${
                  isSubmitting
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {isSubmitting ? "Envoi en cours..." : "Envoyer la demande"}
              </button>
            </div>

            {/* Message de retour */}
            {submitMessage && (
              <div className="mt-4 text-center text-green-600 font-medium">
                {submitMessage}
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CollaborationForm;
